module.exports = function(css) {
  var location = typeof window !== "undefined" && window.location;
  if (!location) {
    throw new Error("fixUrls requires window.location");
  }
  if (!css || typeof css !== "string") {
    return css;
  }
  var baseUrl = location.protocol + "//" + location.host;
  var currentDir = baseUrl + location.pathname.replace(/\/[^\/]*$/, "/");
  var fixedCss = css.replace(/url\s*\(((?:[^)(]|\((?:[^)(]+|\([^)(]*\))*\))*)\)/gi, function(fullMatch, origUrl) {
    var unquotedOrigUrl = origUrl.trim().replace(/^"(.*)"$/, function(o, $1) {
      return $1;
    }).replace(/^'(.*)'$/, function(o, $1) {
      return $1;
    });
    if (/^(#|data:|http:\/\/|https:\/\/|file:\/\/\/|\s*$)/i.test(unquotedOrigUrl)) {
      return fullMatch;
    }
    var newUrl;
    if (unquotedOrigUrl.indexOf("//") === 0) {
      newUrl = unquotedOrigUrl;
    } else if (unquotedOrigUrl.indexOf("/") === 0) {
      newUrl = baseUrl + unquotedOrigUrl;
    } else {
      newUrl = currentDir + unquotedOrigUrl.replace(/^\.\//, "");
    }
    return "url(" + JSON.stringify(newUrl) + ")";
  });
  return fixedCss;
};
